import React from "react";
import { Link } from "@material-ui/core";

const License = () => {
  return (
    <div id="license">
        <Link href="https://creativecommons.org/licenses/by-sa/3.0/za/">
          <img alt="Creative Commons Attribution-ShareAlike 3.0 South Africa License" src="https://i.creativecommons.org/l/by-sa/3.0/88x31.png" />
        </Link>
    </div>
  );
};

export default License;


